import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';
import { RootState } from '../store';
import { Task } from '../../types/task';

interface TasksState {
  currentTask: Task | null;
  loading: boolean;
  error: string | null;
}

const initialState: TasksState = {
  currentTask: null,
  loading: false,
  error: null
};

export const fetchTaskDetails = createAsyncThunk(
  'tasks/fetchTaskDetails',
  async (taskId: number, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/v1/tasks/${taskId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Грешка при зареждане на задачата');
    }
  }
);

export const updateTaskAfterBidAccepted = createAsyncThunk(
  'tasks/updateTaskAfterBidAccepted',
  async (taskId: number, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/v1/tasks/${taskId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Грешка при обновяване на задачата');
    }
  }
);

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    clearCurrentTask: (state) => {
      state.currentTask = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaskDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaskDetails.fulfilled, (state, action) => {
        state.currentTask = action.payload;
        state.loading = false;
      })
      .addCase(fetchTaskDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateTaskAfterBidAccepted.fulfilled, (state, action) => {
        state.currentTask = action.payload;
        state.loading = false;
      });
  }
});

export const { clearCurrentTask } = tasksSlice.actions;

export const selectCurrentTask = (state: RootState) => state.tasks.currentTask;
export const selectTasksLoading = (state: RootState) => state.tasks.loading;
export const selectTasksError = (state: RootState) => state.tasks.error;

export default tasksSlice.reducer; 